import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"

type Props = {
  kbName: string
}

export const KbBreadcrumb = ({ kbName }: Props) => (
  <nav className="flex items-center gap-1 text-sm text-muted-foreground" aria-label="Breadcrumb">
    <Link to="/knowledge-bases" className="hover:text-foreground">
      Knowledge base
    </Link>
    <ChevronRight className="size-4" />
    <span className="truncate text-foreground" aria-current="page">
      {kbName}
    </span>
  </nav>
)
